import type { ProviderKeyTestResult } from '../types.js';

export function providerTestErrorMessage(
  result: ProviderKeyTestResult,
  target: 'provider' | 'litellm',
  t: (key: string, values?: Record<string, string>) => string
): string {
  switch (result.errorType) {
    case 'no_credential':
      return target === 'litellm'
        ? t('providerKeys.errors.noLitellmCredential')
        : t('providerKeys.errors.noProviderCredential');
    case 'unauthorized':
      return target === 'litellm'
        ? t('providerKeys.errors.invalidLitellmCredential')
        : t('providerKeys.errors.invalidApiKey');
    case 'not_found':
      return t('providerKeys.errors.endpointNotFound');
    case 'rate_limited':
      return t('providerKeys.errors.rateLimited');
    case 'server_error':
      return t('providerKeys.errors.serverError');
    case 'network_error':
      return t('providerKeys.errors.networkError');
    default:
      return t('providerKeys.errors.connectionFailed');
  }
}
